// extracted by mini-css-extract-plugin
module.exports = {"responsiveVideo":"Teacher3dCarousel_responsiveVideo__3mkfz"};